module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list-search"
  }, [_c('div', {
    staticClass: "search-wrapper"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search),
      expression: "search"
    }],
    ref: "search_input",
    staticClass: "search-wrapper__search",
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('repitition.search_for') + ' ' + _vm.$t('repitition.skole')
    },
    domProps: {
      "value": (_vm.search)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.search = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "list-search__body"
  }, [_c('ul', _vm._l((_vm.searchList), function(option) {
    return _c('li', [_c('a', {
      attrs: {
        "href": option.url,
        "data-no-turbolink": "true"
      },
      on: {
        "click": function($event) {
          return _vm.chooseItem(option)
        }
      }
    }, [_vm._v(_vm._s(option.name))])])
  }), 0)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1d4d323a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ListWithSearch.vue
// module id = 1498
// module chunks = 1